import React from 'react';
import classnames from 'classnames';
import {useNavigate} from 'react-router-dom';
import ButtonAction from '../../../../common/components/ui/ButtonAction';
import styles from './ButtonLink.module.scss';

type ButtonLinkTypes = {
  link: string
  label: string | React.ReactNode
  customClassnames?: string
};

const ButtonLink = ({
                      link,
                      label,
                      customClassnames,
                    }: ButtonLinkTypes) => {
  const navigate = useNavigate();

  return (
    <ButtonAction
      variant={'link'}
      label={label}
      customClassnames={{container: classnames(styles.link, customClassnames)}}
      onClick={() => navigate(link)}
    />
  );
};

export default ButtonLink;
